var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('modal',{ref:"modalEliminarImagen",attrs:{"titulo":"Eliminar Imagen","icon":"trash"},on:{"guardar":_vm.eliminarImagen}},[_c('div',{staticClass:"row mx-0 justify-center mt-2 mb-4"},[_vm._v(" ¿Desea Eliminar esta Imagen? ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }